const defaultWidth = 20;
const defaultHeight = 20;

export const AdminConsoleIcon = ({ width = defaultWidth, height = defaultHeight, color = '#6A737D' }: SvgProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.9162 15.8328L11.3329 8.24948C12.0829 6.33281 11.6662 4.08281 10.0829 2.49948C8.41621 0.832814 5.91621 0.499481 3.91621 1.41615L7.49954 4.99948L4.99954 7.49948L1.33288 3.91615C0.332876 5.91615 0.749543 8.41615 2.41621 10.0828C3.99954 11.6661 6.24954 12.0828 8.16621 11.3328L15.7495 18.9161C16.0829 19.2495 16.5829 19.2495 16.9162 18.9161L18.8329 16.9995C19.2495 16.6661 19.2495 16.0828 18.9162 15.8328Z"
        fill={color}
      />
    </svg>
  );
};

AdminConsoleIcon.displayName = 'AdminConsoleIcon';
